import { FormStatus } from '../types';

export const getCountryCode = window.altibox.commons.countryCode;

export const getCountryPhoneCodeFromHostName: () => '+45' | '+47' = () => (getCountryCode() === 'dk' ? '+45' : '+47');

export const formatPhoneNbr: (nbr: string) => string = (nbr) => `${nbr.slice(0, 3)} ${nbr.slice(3, 5)} ${nbr.slice(5, 8)}`.trim();

export const ariaInvalid = (formStatus: FormStatus, validationFeedback: string) => {
  return validationFeedback !== '' && formStatus === FormStatus.TRIED_SUBMITTING;
};
